<template>
  <v-layout column class='keywords-group-container' :class="isCollapsed && 'keywords-group-container-collapsed'">
    <CheckboxTag
      :text="groupWord"
      type="checkbox"
      :indeterminate="groupSelectedState === 'partial'"
      :selected="selectAllModal"
      :isSelectAll="true"
      :group="groupWord"
      color="orange"
      @selectAllClicked="handleSelectAllClicked"
    ></CheckboxTag>
    <span class="keywords-group-divider-line divider-line divider-line-blue"></span>
    <template v-for="(options, word) in terms">
      <CheckboxTag
        :text="word"
        type="checkbox"
        :key="word"
        color="blue"
        :selected="selectAllChecked || options.isSelected"
        :group="groupWord"
      ></CheckboxTag>
    </template>
  </v-layout>
</template>
<script>
import CheckboxTag from './buttons/CheckboxTag.vue'
import '../../../style/_variables.scss'

export default {
  name: 'KeywordsGroup',
  components: { CheckboxTag },
  props: ['groupWord', 'isCollapsed', 'groupSelectedState', 'terms'],
  data () {
    return {
      selectAllModal: false,
      selectAllChecked: null
    }
  },
  computed: {
    animationSpeed: { get () { return this.$store.getters.getAnimationSpeed } }
  },
  mounted () {
    Object.entries(this.terms).forEach(([term, options], index) => {
      this.animatedKeywords(term, index)
    })
  },
  watch: {
    selectAllModal: function (val) {
      this.groupSelectedState = val === 'selected'
      this.$emit('selectAllClick', this.groupWord)
    }
  },
  methods: {
    animatedKeywords (term, index) {
      const delay = this.animationSpeed * index
      setTimeout(() => {
        this.terms[term].isShowing = true
      }, delay)
    },
    handleSelectAllClicked () {
      this.selectAllChecked = !this.selectAllChecked
    }
  }
}
</script>
<style scoped lang='scss'>
.keywords-group {
  &-container {
    border-radius: $length-med-s;
    background-color: $grey-400;
    max-width: fit-content;
    min-width: 150px;
    padding: 7px 0;
    & > * {
      margin: 3px 10px;
    }
    &-collapsed {
      max-height: 150px;
      filter: blur(1px);
      overflow: hidden;
    }
  }
  &-divider-line {
    width: 90%;
    align-self: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/parts/utils/KeywordsGroup.vue